import { render, staticRenderFns } from "./WikiSelectionModal.vue?vue&type=template&id=c39574b4&scoped=true"
import script from "./WikiSelectionModal.vue?vue&type=script&lang=js"
export * from "./WikiSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./WikiSelectionModal.vue?vue&type=style&index=0&id=c39574b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39574b4",
  null
  
)

export default component.exports